import styled, { css } from 'styled-components'
import {
    colorBrandPrimary,
    colorNeutral,
    colorNeutralGrey,
    fontFamily,
} from '../../global.style';
import { media } from '../../layouts/utils';

export const Wrapper = styled.div`
    width: 100%;
    bottom: 0;
    background-color: #fff;
    display: flex;
    flex: 1;
`

export const ContainerAzul = styled.div`
    width: 100%;
    margin-top: 0;
    background-color: ${colorBrandPrimary.marine};
    align-items: center;
    display: flex;
    flex-direction: column;

    ${media.phone`
        padding: 0 48px;
    `}
    ${media.smallPhone`
        padding: 0 32px;
    `}
`

export const ContainerElementos = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    margin-top: 50px;
    margin-bottom: 0;
    position: relative;

    ${media.wide`
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          margin: 171px 0 0 0;
          justify-items: flex-start;
          padding-left: 24px;
     `}

     ${media.large`
        grid-template-columns: 1fr;
        padding-right: 24px;
     `}

    ${media.phone`
        display: flex;
        flex-direction: column;
        margin-top: 171px;
        margin-left: 0;
        padding-left: 0;
    `}

    ${media.smallPhone`
        display: flex;
        flex-direction: column;
        margin-top: 171px;
        margin-left: 0;
        padding-left: 0;
    `}
`

export const BlocoMedia = styled.div`
    display: grid;
    grid-auto-flow: row;
    justify-content: space-between;
    align-items: flex-start;
    gap: 10px;
    margin-right: 10px;

    ${media.wide`
        justify-self: flex-start;
    `}


`


export const Texto = styled.span`
    color: ${colorNeutralGrey["50"]};
    font-size: 14px;
    letter-spacing: 0;
    line-height: 15.6px;
    font-family: ${fontFamily.neutral};
    width: 190px;

    ${media.phone`
        p {
            margin: 16px 0;
        }
    `}
`

export const TextoLegalInfo = styled.span`
    color: #ACA6BE;
    font-size: 14px;
    letter-spacing: 0;
    line-height: 15.6px;
    font-family: ${fontFamily.neutral};
    width: 190px;

    ${media.phone`
        p {
            margin: 16px 0;
        }
    `}
    p {
        color: #fff;
    }
`

export const TextoPequeno = styled(Texto)`
    font-size: 14px;
    width: auto;
    padding-bottom: 10px;
`
export const TextoMedio = styled(Texto)`
    font-size: 16px !important;
    width: auto;
    padding-bottom: 10px;
`
export const ContainerRedesSociaisFooter = styled.div`
    width: 70%;
    display: grid;
    grid-auto-flow: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 25px;

    ${media.phone`
        img {
          width: 24px;
        }
    `}
`

export const SpacerEntreBlocos = styled.div`
    ${media.desktop`
        margin: 5px;
    `}
    margin: 30px;
`

export const ImgFooterDog = styled.img`
    height: 303px;
    width: 218px;
    margin-top: -125px;
    margin-bottom: 30px;
    margin-left: 50px;

    ${media.wide`
        height: auto;
        width: 93px;
        position: absolute;
        top: -66px;
        left: 50%;
        margin-left: -46px;
    `}
`

export const ImgGooglePlay = styled.img`
    height: 38px;
    width: 127px;
`

export const ImgAppStore = styled.img`
    height: 38px;
    width: 114px;
`

export const ContainerMobileStores = styled.div`
  img{
    margin-right: 24px;
  }

  ${media.smallPhone && css`
    display: flex;
    flex-direction: row;
  `}
  ${media.desktop`
        padding-bottom: 0;
        min-height: 40px;
        margin-bottom: 8px;
    `
    }
  padding-bottom: 55px;
`;

export const ContainerUmaMarcaFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  img{
    padding: 0 5px;
  }
`

export const ContainerDireitosFooter = styled.div`
    width: 100%;
    display: grid;
    grid-auto-flow: column;
    justify-content: flex-start;
    align-items: center;
    gap: 15px;
    margin-top: 35px;

    a:hover {
      border-bottom: 2px solid #fff;
    }

    ${media.phone`
        display: block;
    `}
    ${media.desktop`
        align-items: flex-start;
        margin-top: 0;
    `}
`

export const LinkFooterExternal = styled.a`
    color: ${(props) =>
        props.dark ? colorBrandPrimary.marine : colorNeutral.light};
    font-family: ${fontFamily.brand};
    font-size: ${(props) => (props.small ? '12px' : '14px')};
    width: 190px;
    cursor: pointer;
    text-align: start;
    text-decoration: none;
`

export const ImgSimplifique = styled.img`

`
export const ImgSelo = styled.img`
    width: 64px;

    ${media.phone`
        width: 56px;
        margin-bottom: 16px;
    `}
`

export const Row = styled.div`
    display: flex;
    padding-left: 20%;
    width: 100%;

    ${media.large`
        padding-left: 0;
        margin-bottom: 32px;
    `}
`

export const Column = styled.div`
    display: flex;
    flex-direction: column;
    &:first-child {
        padding-right: 100px;
    }

    ${media.large`
        &:first-child {
            padding-right: 48px;
        }   
        
    `}
`
